import * as React from "react";
import { toJS } from "mobx";
import { TravelersPicker } from "./TravelersPicker";
import { TravelersContentProps, Travelers } from "../typings";
import { LobErrorSummary } from "../../LobErrorSummary/LobErrorSummary";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkHeading } from "uitk-react-text";

export const TravelersContent = (props: TravelersContentProps) => {
  const roomRefs: React.RefObject<HTMLHeadingElement>[] = [];
  const { formatText } = useLocalization();
  const [totalRoomRefs, setTotalRoomRefs] = React.useState<number>(0);
  const [travelers, setTravelers] = React.useState<Travelers>(toJS(props.travelers));
  const [formError, setFormError] = React.useState<string>(props.invalid || "");
  const [errorLocArgs, setErrorLocArgs] = React.useState<any>([]);

  const setAndSaveTravelers = (t: Travelers) => {
    setTravelers(t);
    props.onChange(t);
  };

  React.useEffect(() => {
    const lastRoomRef = roomRefs[roomRefs.length - 1];
    if (!!lastRoomRef && !!lastRoomRef.current) {
      lastRoomRef.current.focus();
    }
    //handles each error loc args depending on validations
    if (formError) {
      if (props.lobState?.validateInfantsPerTraveler && !props.lobState?.validateInfantsPerTraveler()) {
        setErrorLocArgs([
          props.lobState?.config.travelers.minInfantPerTraveler,
          props.lobState?.config.travelers.minAdultAge,
        ]);
      } else if (props.lobState?.validateUnattendedInfantInLap && !props.lobState?.validateUnattendedInfantInLap()) {
        setErrorLocArgs([props.lobState?.config.travelers.minAdultAge]);
      } else {
        setErrorLocArgs([props.lobState?.config.travelers.maxBookableTravelers]);
      }
    }
  }, [totalRoomRefs, formError]);

  return (
    <>
      <div className="all-x-padding-four all-t-padding-four">
        <UitkHeading level={3} size={500}>
          {formatText(props.config.dialogTitleToken)}
        </UitkHeading>
        {formError && (
          <LobErrorSummary className="all-t-padding-two" locHeadingToken={formError} locHeadingArgs={errorLocArgs} />
        )}
      </div>
      <TravelersPicker
        {...props}
        roomRefs={roomRefs}
        totalRoomRefs={totalRoomRefs}
        setTotalRoomRefs={setTotalRoomRefs}
        travelers={travelers}
        setTravelers={setAndSaveTravelers}
        setFormError={setFormError}
      />
    </>
  );
};
